import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';


import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { GenerateIncrementlettersPreviewPopupComponent } from 'src/app/shared/popups/generate-incrementletters-preview-popup/generate-incrementletters-preview-popup.component';
import { OfferletterviewComponent } from '../elcm/offerletterview/offerletterview.component';
import * as saveAs from 'file-saver';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-elcm-offer-letter-report',
  templateUrl: './elcm-offer-letter-report.component.html',
  styleUrls: ['./elcm-offer-letter-report.component.scss'],
})
export class ElcmOfferLetterReportComponent implements OnInit {
  yearList: any[] = [];
  selectedYear: any;
  buttonColorName: any;
  loggedInUserCompanyID: any;
  incrementId: any;
  loggedInUserRole: any;
  getIncrementFyYearList: any[] = [];
  fromYear: any;
  toYear: any;
  dropdownSettings: IDropdownSettings = {};
  selectedDepartment: any;
  selectedBand: any;
  selectedManager: any;
  selectedEmployee: any;
  selectedRating: any;
  managerId: any;
  employeeId: any;
  searchOfferTableData
    : any;
  loggedInCompanyFiscalyear: any;
  getIncrementInputYear: any[] = [];
  companyYears: any[] = [];
  getDepartmentsList: any[] = [];
  getBandList: any[] = [];
  getManagerList: any[] = [];
  getEmployeeList: any[] = [];
  getSelectedRating: any[] = [];
  getRatingData: any[] = [];
  isShowDownloadBtn: boolean = false;
  selectAllChecked: boolean = false;

  incrementLetterData: any[] = [];

  constructor(private route: Router, private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, public dialog: MatDialog, public sharedService: SharedService,
    private http: HttpClient) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getpmsyearlist();

  }
  pmsYears: any = []
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {

  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {

  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }

  //       if (ele?.year == yearValue) {
  //         console.log("dgmfdgl");

  //         this.selectedYear = ele?.year;
  //         this.getEmployeeListForOfferleter();



  //       }


  //     });
  //   })
  // }


  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     // Convert year ranges from API response into "YYYY-YYYY" format
  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       let yearParts = ele.split('_');
  //       let formattedYear = `${yearParts[0]}-${yearParts[1]}`;
  //       this.pmsYears.push({ year: formattedYear });
  //     });

  //     // Get the current date
  //     const today = new Date();
  //     const currentYear = today.getFullYear();
  //     const currentMonth = today.getMonth(); // 0 = Jan, 11 = Dec
  //     let fiscalStartYear, fiscalEndYear;

  //     // Manage according to the selected fiscal year format
  //     switch (this.loggedInCompanyFiscalyear) {
  //       case 'Jan_Dec':
  //         fiscalStartYear = currentYear;
  //         fiscalEndYear = currentYear;
  //         break;

  //       case 'Apr_Mar':
  //         if (currentMonth < 3) { // Jan, Feb, Mar
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;

  //       case 'July_Jun':
  //         if (currentMonth < 6) { // Jan to Jun
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;

  //       case 'Oct_Sep':
  //         if (currentMonth < 9) { // Jan to Sep
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;

  //       default:
  //         console.warn("Invalid Fiscal Year Format");
  //         return;
  //     }

  //     const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

  //     // Find and set the correct year from the available list
  //     this.pmsYears.forEach((ele: any) => {
  //       if (ele?.year == yearValue) {
  //         console.log("dgmfdgl");

  //         this.selectedYear = ele?.year;
  //         this.getEmployeeListForOfferleter();



  //       }
  //     });


  //   });
  // }



      getpmsyearlist() {
        this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
          this.pmsYears = formatYearRanges(data?.data?.yearRanges);
    
          const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    
          const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      
          this.setSelectedYear(yearValue);
        // Additional function calls
        this.getEmployeeListForOfferleter();
        });
      }
    setSelectedYear(yearValue: string): void {
      const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
      if (selectedYearObj) {
        this.selectedYear = selectedYearObj?.year;
        let test = selectedYearObj?.year.split('-');
           
      }
    }
  onYearChange(event: any) {
    this.selectedEmployeeForFilter=[];
    this.selectedDepartment=[];
    this.selectedYear = event;
    this.getEmployeeListForOfferleter();
  }







  onSelectDepartment() {
    if (this.selectedDepartment.length > 0) {

      this.filterDepartMentList();

    }
  }

  onDeSelectDepartment() {
    this.filterDepartMentList();


  }



  selectAllDepartment(items: any): void {
    this.selectedDepartment = items;
    this.filterDepartMentList();
  }

  onDeSelectAllDepartment() {
    this.selectedDepartment = [];
    this.selectedEmployeeForFilter = [];
    this.filterDepartMentList();

  }








  // Employee 

  selectedEmployeeForFilter: any
  onSelectdEmp() {
    if (this.selectedEmployeeForFilter.length > 0) {
      this.filterEmployeeList();
    }
  }
  onDeSelectdEmployee() {
    this.filterEmployeeList()
  }

  selectAllEmployee(items: any): void {
    this.selectedEmployeeForFilter = items;
    this.filterEmployeeList()
  }

  onDeSelectAllEmployee() {
    this.selectedEmployeeForFilter = [];
    this.filterEmployeeList()

  }

  filterEmployeeList() {
    if (this.selectedEmployeeForFilter.length > 0) {

      let findId = this.selectedEmployeeForFilter.map((elm: any) => elm.id);
      let employee = this.curretofferLetterData.filter((elm: any) => findId.includes(elm.candidateId));
      this.offerLetterData = employee
    } else {
      if (this.selectedDepartment.length > 0) {


        let findId = this.selectedDepartment.map((elm: any) => elm.id.trim().toLowerCase());
        let employee = this.curretofferLetterData.filter((elm: any) =>
          elm.department && findId.includes(elm.department.trim().toLowerCase()) // Normalize and check
        );


        this.offerLetterData = employee;
      } else {

        this.offerLetterData = this.curretofferLetterData;
      }
    }
  }


  filterDepartMentList() {
    if (this.selectedDepartment.length > 0) {

      let findId = this.selectedDepartment.map((elm: any) => elm.id.trim().toLowerCase());
      let employee = this.curretofferLetterData.filter((elm: any) =>
        elm.department && findId.includes(elm.department.trim().toLowerCase()) // Normalize and check
      );
      this.offerLetterData = employee;
      console.log(employee);
      this.getEmployeeList = [];
      this.selectedEmployeeForFilter = [];
      employee.forEach((elm: any) => {
        if (!this.getEmployeeList.some((candidate: any) => candidate.candidateId === elm.candidateId)) {

          this.getEmployeeList.push({
            id: elm.candidateId,
            name: elm.firstName + " " + elm.lastName
          })
        }
      })

    } else {
      this.offerLetterData = this.curretofferLetterData;

      this.curretofferLetterData.forEach((elm: any) => {
        if (!this.getEmployeeList.some((candidate: any) => candidate.candidateId === elm.candidateId)) {

          this.getEmployeeList.push({
            id: elm.candidateId,
            name: elm.firstName + " " + elm.lastName
          })
        }
      })
    }
  }



  private debounceTimer: any;

  appoinmentReportSearch() {
    console.log(this.searchOfferTableData
    );

    // If search is empty, reset to original data
    if (!this.searchOfferTableData
      || this.searchOfferTableData
        .trim() === '') {
      console.log("Inside if - Resetting data");
      this.offerLetterData = [...this.offerLetterData]; // Reset data
      return;
    }

    // Convert search text to lowercase for case-insensitive comparison
    const searchTextLower = this.searchOfferTableData
      .toLowerCase().trim();

    // Filter appointment data based on search term
    this.offerLetterData = this.curretofferLetterData.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined values
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );

    console.log("Filtered Data:", this.offerLetterData);
  }




  allSelectedData: any = []
  toggleSelectAll() {
    this.offerLetterData.forEach((item: any) => item.isChecked = this.selectAllChecked);

    this.allSelectedData = this.offerLetterData
    this.isShowDownloadBtn = this.selectAllChecked; // Show download if all are selected

  }
  offerlettterDataForSingleSelection: any = []
  checkedEmployees: any = []
  onCheckboxChange(event: MatCheckboxChange, employee: any) {
    if (event.checked) {
      // Add employee to the checked list if checked
      this.checkedEmployees.push(employee);
    } else {
      // Remove employee from checked list if unchecked
      this.checkedEmployees = this.checkedEmployees.filter((elm: any) => elm.candidateId !== employee.candidateId);
    }

    // Update appointment letter data to show only checked employees
    this.offerlettterDataForSingleSelection = [...this.checkedEmployees];
    const allChecked = this.offerLetterData.every((item: any) => item.isChecked);
    const anyChecked = this.offerLetterData.some((item: any) => item.isChecked);


    this.selectAllChecked = allChecked; // Update 'Select All' state
    this.isShowDownloadBtn = anyChecked; // Show download button if at least one is checked
  }
  downloadSelected() {
    const selectedIds = this?.offerLetterData
      ?.filter((data: any) => data.isChecked)
      .map((data: any) => data.candidateId);

    if (!selectedIds || selectedIds.length === 0) {
      console.warn("No items selected for download.");
      return;
    }

    if (this.selectAllChecked) {

      this.allSelectedData = this.offerlettterDataForSingleSelection.length > 0 ? this.offerlettterDataForSingleSelection : this.allSelectedData;
      this.allSelectedData.forEach((elm: any) => {
        this.viewDocument(elm.fileName);
      })
    } else {
      if (!this.offerlettterDataForSingleSelection) {
        console.error("Download URL is not defined.");
        return;
      }
      // const fileName = this.appoinmentlettterData.split('/').pop() || "downloaded-file";
      this.offerlettterDataForSingleSelection.forEach((elm: any) => {
        this.viewDocument(elm.fileName);
      })
    }

  }


  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }

  onClickPreviewLetter(userName: any, userId: any, fileName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      userName: userName,
      userId: userId,
      fileName: fileName,
      incrementLetterData: this.incrementLetterData // Pass the full data here
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(OfferletterviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => { });
  }



  filteredEmployees: any = [];
  employees: any = [];
  offerLetterData: any = [];
  curretofferLetterData: any = [];
  getEmployeeListForOfferleter() {
    // this.httpService.callGetService(`${this.config.employeeList}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {
    //   this.filteredEmployees = record.data;
    // this.employees = this.filteredEmployees.filter((elm: any) => elm.status == 'OFFER_LETTER_SENT'); // Initialize filtered list
    // let offerLetterData = this.employees.map((elm: any) => ({
    //   ...elm,
    //   isChecked: false
    // }))
    // this.offerLetterData = offerLetterData;
    // this.curretofferLetterData = offerLetterData;
    // this.curretofferLetterData.forEach((elm: any) => {
    //   if (!this.getEmployeeList.some((candidate: any) => candidate.candidateId === elm.candidateId)) {

    //     this.getEmployeeList.push({
    //         id: elm.candidateId,
    //         name: elm.firstName + " " + elm.lastName
    //       })
    //   }
    // })
    this.httpService.callGetService(`${this.config.getListbyCandidateIdAndCompanyId}?companyId=${this.loggedInUserCompanyID}`).subscribe((record: any) => {
      this.filteredEmployees = record.data.candidate.filter((elm: any) => elm.year == this.selectedYear);

      this.employees = this.filteredEmployees.filter(
        (elm: any) => (elm.fileName !== null && elm.fileName !== '')
      ); // Initialize filtered list

      let offerLetterData = this.employees.map((elm: any) => {
        // Find all records that match by candidateId
        let matchData = record.data.currentEmploymentFormByHR.filter(
          (rec: any) => rec.candidateId === elm.candidateId
        );

        return {
          ...elm,
          // If there are multiple matches, join departments into a string or store as an array
          department: matchData.length > 0
            ? matchData.map((item: any) => item.department).join(', ')  // Convert to string
            : null, // If no match, return null
          isChecked: false
        };
      });
      this.offerLetterData = offerLetterData.filter((elm: any) => elm.year == this.selectedYear);
      this.curretofferLetterData = offerLetterData.filter((elm: any) => elm.year == this.selectedYear);
      this.getEmployeeList = []
      this.curretofferLetterData.forEach((elm: any) => {
        if (!this.getEmployeeList.some((candidate: any) => candidate.candidateId === elm.candidateId)) {

          this.getEmployeeList.push({
            id: elm.candidateId,
            name: elm.firstName + " " + elm.lastName
          })
        }
      })
      this.getDepartmentsList = []
      this.curretofferLetterData.forEach((elm: any) => {
        if (elm?.department) { // Ensure department is not undefined or null
          const deptName = elm.department.trim().toLowerCase(); // Normalize department name

          // Debugging: Log to verify department names
          console.log("Checking Department:", deptName);

          // Check if department already exists in the list
          if (!this.getDepartmentsList.some((candidate: any) => candidate.name.trim().toLowerCase() === deptName)) {
            this.getDepartmentsList.push({
              id: deptName, // Store normalized name
              name: elm.department.trim(), // Keep original case for display
            });
          }
        }
      });

      // Debugging: Log final department list
      console.log("Final Department List:", this.getDepartmentsList);


    })


  }







}
